import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FieldProducers } from '../models/field-producers';

@Injectable({
  providedIn: 'root'
})
export class FieldProducersService {
  apiEndpoint = environment.apiEndpoint;

  constructor(private http: HttpClient) { }

  get(campaignId: number, fieldId: number): Observable<any> {
    return this.http.get(`${this.apiEndpoint}FieldProducers/Campaign/${campaignId}/Field/${fieldId}`);
  }

  save(fieldProducer: FieldProducers): Observable<any> {
    return this.http.post<FieldProducers>(`${this.apiEndpoint}FieldProducers/`, fieldProducer);
  }

  delete(campaignId: number, fieldId: number): Observable<any> {
    return this.http.delete(`${this.apiEndpoint}FieldProducers/Campaign/${campaignId}/Field/${fieldId}`);
  }
}
